<template>
  <div class="dialog_box">
    <el-dialog title="权限配置" :visible="show" width="878px" @close="dialogClose" top="10vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <!-- <div class="select_box">
          <el-radio v-model="radio" label="1">PC后台菜单</el-radio>
          <el-radio v-model="radio" label="2">APP菜单</el-radio>
        </div> -->
        <div class="permission_box">
          <div class="tree">
            <div class="tree_title">所有菜单</div>
            <el-tree :data="roleList" show-checkbox ref="tree" node-key="id" :props="defaultProps"
              :default-checked-keys="autIdList" @check="check" :default-expand-all="true">
              <!-- :default-expanded-keys="autIdList" -->
            </el-tree>
          </div>

          <div class="tree">
            <div class="tree_title">授权菜单</div>
            <ul>
              <li v-for="(item, index) in autMenuList" :key="index">
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="tree">
            <div class="tree_title">授权功能</div>
            <ul>
              <li v-for="(item, index) in autOperateList" :key="index">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      form: {},
      imgUrl: "",
      stateList: [],
      rules: {},
      radio: "1",
      roleList: [],
      autIdList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      autMenuList: [], // 授权菜单
      autOperateList: [], // 授权功能
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.autIdList = [];
        this.$http
          .queryRoleMenuPerm({ roleId: this.data.roleId })
          .then((res) => {
            if (res.code == 0) {
              let authList = res.data;
              console.log("后端返回的选中数据", authList);
              this.$http.getMenutree({ isTree: true, hasPerms: 1 }).then((isTree) => {
                if (isTree.code === 0) {
                  this.roleList = isTree.data;
                  authList.forEach(i => {
                    isTree.data.forEach(a => {
                      if (!a.children) {
                        if (i === a.id) {
                          this.autIdList.push(a.id)
                        }
                      } else {
                        a.children.forEach(b => {
                          if (!b.children) {
                            if (i === b.id) {
                              this.autIdList.push(b.id)
                            }
                          } else {
                            b.children.forEach(c => {
                              if (!c.children) {
                                if (i === c.id) {
                                  this.autIdList.push(c.id)
                                }
                              }
                            })
                          }
                        })
                      }
                    })
                  })
                  console.log("autIdList", this.autIdList);
                }
              });

              this.$http.getMenutree({ isTree: false, hasPerms: 1 }).then(notTree => {
                if (notTree.code === 0) {
                  let arr = [];
                  let brr = [];
                  let crr = [];
                  authList.forEach(a => {
                    notTree.data.forEach(b => {
                      if (a == b.menuId) {
                        if (b.menuType == 'B') {
                          brr.push(b);
                        } else if (b.menuType == "M" || b.menuType == "C") {
                          arr.push(b);
                        }
                      }
                    })
                  })
                  this.autMenuList = arr.map(i => {
                    return {
                      name: i.menuName,
                      id: i.menuId
                    }
                  }).sort((a, b) => {
                    return a.id - b.id;
                  });
                  this.autOperateList = brr.map(i => {
                    return {
                      name: i.menuName,
                      id: i.menuId
                    }
                  }).sort((a, b) => {
                    return a.id - b.id;
                  });
                }
              })
            } else {
              this.roleList = [];
            }
          });
      }
    },
  },
  created () { },
  methods: {
    confirm () {
      let menuList = [];
      this.autMenuList.forEach((i) => {
        menuList.push(i.id);
      });
      this.autOperateList.forEach((i) => {
        menuList.push(i.id);
      });
      let params = {
        menuList,
        roleId: this.data.roleId,
      };
      this.$http.roleMenuPerm(params).then((res) => {
        if (res.code === 0) {
          this.$message.success(res.msg);
          this.autIdList = [];
          this.$emit("update:show", false);
        } else {
          this.$message.info(res.msg);
        }
      });
    },
    check (data, treeData) {
      this.autMenuList = [];
      this.autOperateList = [];
      let treeArr = treeData.checkedNodes;
      let notAll = treeData.halfCheckedNodes;
      treeArr = treeArr.concat(notAll);
      treeArr.forEach((a) => {
        if (a.type == "M" || a.type == "C") {
          this.autMenuList.push(a);
        } else if (a.type == "B") {
          this.autOperateList.push(a);
        }
      });
      this.autMenuList = this.autMenuList.sort((a, b) => {
        return a.id - b.id;
      });
      this.autOperateList = this.autOperateList.sort((a, b) => {
        return a.id - b.id;
      });
    },
    handleNodeClick (data) {
      console.log(data);
    },
    dialogClose () {
      this.autMenuList = [];
      this.autOperateList = [];
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.el-form-item__content {
  width: 240px;
}

.permission_box {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  min-height: 588px;

  .tree {
    width: 188px;
    border: 1px solid #b4bbc5;
    box-sizing: border-box;

    .tree_title {
      width: 100%;
      height: 25px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      font-weight: 500;
      color: #000000;
      border-bottom: 1px solid #b4bbc5;
    }
  }
}

/deep/.el-tree-node {
  .el-tree-node__content {
    height: 40px;
  }
}

/deep/.el-dialog__body {
  max-height: 70vh;
  overflow-y: scroll;
}

ul {
  list-style: none;
  line-height: 40px;
  margin: 0 0 0 24px;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/user_Admin/component/permission.vue